import React, { Fragment } from 'react';
import PropTypes, { object } from 'prop-types';
import { useTranslation } from 'react-i18next';

import Cell from './Cell/Cell';
import {
  DateTime,
  Table,
  Member,
  Text,
  Network,
  Location
} from 'components/common/Elements/Elements';

import { getInitialsFull } from 'utils/common';

import activityTypes from 'data/activity-types.json';

import classes from './PlatformActivitiesTable.module.scss';

const TableRow = ({ company, tableConf, row, mouseEnter }) => {
  const { t } = useTranslation('activity');
  const big =
    company.industry !== '-' ||
    company.department !== '-' ||
    company.industry !== 'NA' ||
    company.department !== 'NA';

  const user = company.releasedBy;

  let name = '';

  if (user.displayName) {
    name = user.displayName;
  } else if (user.firstName && user.lastName) {
    name = `${user.firstName} ${user.lastName}`;
  } else if (user.firstName) {
    name = user.firstName.split('.').join(' ');
  }

  if (!company.releasedBy.displayName) {
    company.releasedBy.displayName = name;
  }

  const member = {
    fullName: name,
    description: user.email,
    initials: getInitialsFull(name),
    initialsColor: user.initialsColor
  };

  const transleteActivity = type => {
    let name = '';
    activityTypes.forEach(elem =>
      elem.children.forEach(e => {
        if (e.id === type) {
          name = e.name;
        }
      })
    );

    return name === '' ? type : name;
  };

  return (
    <Table.Row className={classes.row}>
      {tableConf.map(({ show, field }, ind) => {
        const cellProps = {
          row: row,
          mouseEnter: mouseEnter,
          ind: ind,
          field: field,
          big: big
        };

        return (
          <Fragment key={`${field}-${company.email}}`}>
            {show && field === 'member' && (
              <Cell cellProps={cellProps}>
                <Member member={member} />
              </Cell>
            )}
            {show && field === 'createdAt' && (
              <Cell cellProps={cellProps}>
                <DateTime date={company.createdAt} time />
              </Cell>
            )}
            {show && field === 'eventName' && (
              <Cell cellProps={cellProps}>
                <div>
                  {transleteActivity(company.eventName) !==
                  company.eventName ? (
                    <Text
                      type="p"
                      className={classes.actitity}
                      dangerouslySetInnerHTML={{
                        __html: t(
                          `activity:messages.${transleteActivity(
                            company.eventName
                          )}`,
                          {
                            ...company
                          }
                        )
                      }}
                    />
                  ) : (
                    <p>
                      {company.eventName
                        .substr(company.eventName.indexOf('.', 13) + 1)
                        .replaceAll('.', ' ')}
                    </p>
                  )}

                  {company.device && (
                    <Text size={2} type="p" className={classes.company}>{`${t(
                      'activity:LABEL_DEVICE'
                    )}: ${t(
                      `activity:devices.${company.device.deviceType}`
                    )}`}</Text>
                  )}
                </div>
              </Cell>
            )}
            {show && field === 'network' && (
              <Cell cellProps={cellProps}>
                {company.network && <Network data={company.network} />}
              </Cell>
            )}
            {show && field === 'addressCountry' && (
              <Cell cellProps={cellProps}>
                {company.addressCountry ? (
                  <Location country={company.addressCountry} size={32} />
                ) : (
                  'NA'
                )}
              </Cell>
            )}
          </Fragment>
        );
      })}
    </Table.Row>
  );
};

TableRow.propTypes = {
  company: PropTypes.object,
  tableConf: PropTypes.arrayOf(object),
  row: PropTypes.string,
  mouseEnter: PropTypes.func
};

export default TableRow;
